/**
 * Calendly link helper — appends the visitor's captured UTM params onto the
 * Calendly booking URL so attribution carries through once the form is gone.
 *
 * Calendly natively surfaces utm_source / utm_medium / utm_campaign /
 * utm_content / utm_term in its own analytics + export, so no extra wiring
 * is required beyond appending them to the URL.
 *
 * Usage:
 *   <a href={calendlyUrl()} target="_blank" rel="noopener noreferrer">Book</a>
 *   <a href={calendlyUrl({ pillar: "rpo" })} ...>  // adds utm_content=rpo if none set
 */
import { getAttribution } from "./attribution";

export const CALENDLY_BASE_URL = "https://calendly.com/a4assist/15min";

const PASS_THROUGH_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export function calendlyUrl(overrides = {}) {
  const attr = typeof window === "undefined" ? {} : getAttribution();
  const params = new URLSearchParams();

  PASS_THROUGH_KEYS.forEach((k) => {
    const v = overrides[k] ?? attr[k];
    if (v) params.set(k, v);
  });

  // Default utm_content to pillar context if nothing else was set
  if (!params.get("utm_content")) {
    const pillar =
      overrides.pillar ||
      (typeof window !== "undefined" ? attr.pillar_context : null);
    if (pillar && pillar !== "home") params.set("utm_content", pillar);
  }

  const qs = params.toString();
  return qs ? `${CALENDLY_BASE_URL}?${qs}` : CALENDLY_BASE_URL;
}

/** Common target/rel props for anchor tags opening Calendly in a new tab. */
export const calendlyLinkProps = {
  target: "_blank",
  rel: "noopener noreferrer",
};
